import Layout from "@/layout/index.vue";

const routes = [
  {
    path: '/',
    name: 'root',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import('../views/home/index.vue'),
        meta: {
          title: "首页",
          keepAlive: true
        }
      },
      {
        path: "tools",
        name: "tools",
        component: () => import('../views/tools/index.vue'),
        meta: {
          title: "请求工具",
          keepAlive: true
        }
      },
      {
        path: "user",
        name: "user",
        component: () => import('../views/userInfo/index.vue'),
        meta: {
          title: "我的",
          keepAlive: true
        }
      },
    ]
  },
  // // 待办事项 列表页
  // {
  //   path: '/todoInfo',
  //   name: 'todoInfo',
  //   component: () => import('../views/todoInfo/index.vue')
  // },
  // // 待办详情页
  // {
  //   path: '/todoDetails',
  //   name: 'todoDetails',
  //   component: () => import('../views/todoInfo/todoDetails.vue')
  // },



  //  // 免考缓考申请-新增
  //  {
  //   path: '/specialApplyAdd',
  //   name: 'specialApplyAdd',
  //   component: () => import('../views/specialApply/module/add.vue')
  // },
  // // 免考缓考申请-详情
  // {
  //   path: '/specialApplyDetails',
  //   name: 'specialApplyDetails',
  //   component: () => import('../views/specialApply/module/details.vue')
  // },


  // // 体测成绩
  // {
  //   path: '/testResults',
  //   name: 'testResults',
  //   component: () => import('../views/testResults/index.vue')
  // },
  // // 毕业成绩
  // {
  //   path: '/graduationGrades',
  //   name: 'graduationGrades',
  //   component: () => import('../views/graduationGrades/index.vue')
  // },






  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/login/resetPassword.vue')
  },
  {
    path: '/userPassword',
    name: 'userPassword',
    component: () => import('../views/login/userPassword.vue')
  },
  {
    path: '/403',
    name: 'forbidden',
    component: () => import('../layout/403.vue'),
    meta: {
      title: "暂无访问权限"
    }
  },
  {
    path: '/:catchAll(.*)',
    name: 'not-found',
    component: () => import('../layout/404.vue'),
    meta: {
      title: "访问页面不存在",
      keepAlive: true
    }
  },
]
export default routes;
